var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.8433f33c9d43d38e9ffe651a60a36c48.svg#c';
                    var viewUrl = 'sprites.8433f33c9d43d38e9ffe651a60a36c48.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };